import { render, staticRenderFns } from "./LoggedOutLayout.vue?vue&type=template&id=0c56e161&scoped=true&"
import script from "./LoggedOutLayout.vue?vue&type=script&lang=js&"
export * from "./LoggedOutLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoggedOutLayout.vue?vue&type=style&index=0&id=0c56e161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56e161",
  null
  
)

export default component.exports